import { render } from "./BookNowButton.vue?vue&type=template&id=0e220c80&scoped=true"
import script from "./BookNowButton.vue?vue&type=script&lang=js"
export * from "./BookNowButton.vue?vue&type=script&lang=js"

import "./BookNowButton.vue?vue&type=style&index=0&id=0e220c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e220c80"]])

export default __exports__